"use client";

import { replaceImageSizeSrc } from "@winging/util/helper/image";
import { useRouter } from "@/i18n/navigation";
import PricingSchedulingDetail from "@/features/billing/ui/pricing/PricingSchedulingDetail";
import { useAuth } from "@/shared/providers/AuthProvider";

const PricingScheduling = () => {
  const router = useRouter();
  const { user } = useAuth();

  const handleScheduleSettingClick = () => {
    // 로그인 여부에 따라 데이터 관리자 또는 로그인 페이지로 이동한다.
    router.push(user ? "/dashboard/data" : "/auth/sign-in");
  };

  return (
    <div className={"relative mt-[64px] w-full sm:mt-[100px] lg:mt-[180px]"}>
      <img
        className={
          "absolute right-[-32px] top-[-32px] hidden w-[284px] border-none lg:block"
        }
        src={replaceImageSizeSrc(
          "https://cdn.winging.app/static/builder/images/scheduling.png",
          284
        )}
        alt={"스케쥴링 설명 이미지"}
      />
      <h2
        className={
          "hidden text-heading3 font-[800] leading-[48px] sm:block sm:text-heading2"
        }
      >
        혹시 AI가 학습할 데이터가
        <br />
        주기적으로 수집이 필요한 데이터인가요?
      </h2>
      <h2
        className={
          "block break-keep text-heading3 font-[800] leading-[48px] sm:hidden sm:text-heading2"
        }
      >
        AI가 학습할 데이터가 정기적으로 업데이트되어야 하나요?{" "}
      </h2>

      <div className={"hidden text-title2 font-[600] text-gray-800 sm:block"}>
        AI 챗봇이 학습해야 할 데이터가 정기적인 업데이트가 필요한 뉴스와 같은
        정보라면?
      </div>
      <div className={"mt-[42px] flex flex-col justify-between sm:flex-row"}>
        <div>
          <div className={"flex items-center gap-[6px]"}>
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1208_2188)">
                <path
                  d="M20.0013 6.66602V1.66602L13.3346 8.33268L20.0013 14.9993V9.99935C25.518 9.99935 30.0013 14.4827 30.0013 19.9993C30.0013 21.6827 29.5846 23.2827 28.8346 24.666L31.268 27.0993C32.568 25.0494 33.3346 22.616 33.3346 19.9993C33.3346 12.6327 27.368 6.66602 20.0013 6.66602ZM20.0013 29.9993C14.4846 29.9993 10.0013 25.516 10.0013 19.9993C10.0013 18.316 10.418 16.716 11.168 15.3327L8.73463 12.8993C7.43464 14.9493 6.66797 17.3827 6.66797 19.9993C6.66797 27.366 12.6346 33.3327 20.0013 33.3327V38.3327L26.668 31.666L20.0013 24.9993V29.9993Z"
                  fill="#384456"
                />
              </g>
              <defs>
                <clipPath id="clip0_1208_2188">
                  <rect width="40" height="40" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <span className={"text-title1 font-[800] text-[#384456]"}>
              학습데이터 크롤링
            </span>
          </div>
          <div className={"ml-[12px] mt-[6px]"}>
            <div className={"flex items-start gap-[6px]"}>
              <svg
                className={"mt-[6px] min-w-[10px] grow sm:grow-0"}
                width="13"
                height="14"
                viewBox="0 0 13 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.13636 11.0746L1.03409 6.68657L0 8.14925L4.13636 14L13 1.46269L11.9659 0L4.13636 11.0746Z"
                  fill="black"
                />
              </svg>
              <span
                className={
                  "shrink text-body1 text-[#384456] sm:shrink-0 sm:text-title2 lg:font-[800]"
                }
              >
                학습할 데이터 홈페이지 URL을 입력하고 원하는 수집 주기를 설정해
                보세요.{" "}
              </span>
            </div>
            <div className={"flex items-start gap-[6px]"}>
              <svg
                className={"mt-[6px] min-w-[10px] grow sm:grow-0"}
                width="13"
                height="14"
                viewBox="0 0 13 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.13636 11.0746L1.03409 6.68657L0 8.14925L4.13636 14L13 1.46269L11.9659 0L4.13636 11.0746Z"
                  fill="black"
                />
              </svg>
              <span
                className={
                  "shrink text-body1 text-[#384456] sm:text-title2 lg:font-[800]"
                }
              >
                홈페이지의 변경 내용을 주기적으로 수집해 AI가 최신 정보를
                학습하도록 도와드립니다.
              </span>
            </div>
            <div className={"flex items-start gap-[6px]"}>
              <svg
                className={"mt-[6px] min-w-[10px] grow sm:grow-0"}
                width="13"
                height="14"
                viewBox="0 0 13 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.13636 11.0746L1.03409 6.68657L0 8.14925L4.13636 14L13 1.46269L11.9659 0L4.13636 11.0746Z"
                  fill="black"
                />
              </svg>
              <span
                className={
                  "shrink text-body1 text-[#384456] sm:text-title2 lg:font-[800]"
                }
              >
                Pro 요금제 이용 시 월 10회 무료 제공되며, 이후에는 사용량에 따라
                요금이 부과됩니다.{" "}
              </span>
            </div>
          </div>
          <div
            className={
              "ml-[28px] text-caption2 text-gray-400 sm:ml-[32px] sm:text-body2"
            }
          >
            본 기능은 여러 에이전트에서 이용 시 각 에이전트의 사용 횟수를
            합산하여 총 사용량으로 집계됩니다.
          </div>
        </div>
        <div className={"hidden main:block"}>
          <div
            className={
              "mt-[32px] flex w-[312px] min-w-[312px] flex-col items-center rounded-md border border-gray-200 bg-white px-[15px] py-[18px]"
            }
          >
            {/* 요금 안내 카드는 강조 문구와 보조 문구의 위계를 맞춰 정돈한다. */}
            <div
              className={
                "text-center text-title1 font-[800] text-primary-dark"
              }
            >
              기본
            </div>
            <div className={"mt-[2px] text-center text-label2 text-gray-400"}>
              Pro 요금제 이용 시 사용 가능
            </div>
            <div className={"mt-[12px] text-center"}>
              <span
                className={
                  "whitespace-nowrap text-title1 font-[800] text-primary-dark"
                }
              >
                월 10회 무료 제공
              </span>
            </div>
          </div>
          <ul className={"mt-[8px] flex justify-end pr-[2px]"}>
            <li className={"list-disc text-body2 text-gray-400"}>
              초과 1회당 300원
            </li>
          </ul>
        </div>
      </div>
      <div
        className={
          "mt-[10px] flex items-end justify-center gap-[6px] text-center sm:mt-[26px] sm:justify-end lg:justify-center"
        }
      >
        <div
          className={
            "block w-fit grow rounded-md border border-gray-200 bg-white px-[12px] py-[10px] sm:shrink sm:grow-0 sm:px-[18px] sm:py-[14px] main:hidden"
          }
        >
          {/* 모바일 요금 안내도 데스크톱과 동일한 정책 내용으로 노출한다. */}
          <div className={"text-caption2 text-gray-400 sm:text-label2"}>
            Pro 요금제 이용 시 사용 가능
          </div>
          <div className={"mt-[2px] flex items-end justify-center"}>
            <div className={"font-[600] text-primary-dark sm:text-title1"}>
              월 10회 무료 제공
            </div>
          </div>
          <div className={"mt-[2px] text-caption2 text-gray-400 sm:text-label2"}>
            초과 1회당 300원
          </div>
        </div>
        <button
          type={"button"}
          onClick={handleScheduleSettingClick}
          className={
            "block h-[53px] shrink items-center justify-center rounded-md bg-primary px-[28px] text-caption2 font-[800] text-white main:hidden main:h-[66px] main:w-[314px] main:px-0"
          }
        >
          데이터 학습 주기 <br />
          설정하기
        </button>
      </div>
      <PricingSchedulingDetail />
      <div className={"hidden w-full justify-center main:flex"}>
        <button
          type={"button"}
          onClick={handleScheduleSettingClick}
          className={
            "flex h-[53px] shrink items-center justify-center rounded-md bg-primary px-[28px] text-caption2 font-[600] text-white main:h-[66px] main:w-[314px] main:px-0 main:text-title2"
          }
        >
          데이터 학습 주기 설정하기
        </button>
      </div>
    </div>
  );
};

export default PricingScheduling;
